import React from 'react';
import { hasValue } from '@famly/stat_ts-utils_has-value';
/**
 * Dismisses a toast once `duration` has elapsed.
 *
 * `onDismiss` is read through a ref so that a caller passing a fresh arrow on every render — the
 * normal shape of `() => clearStatus(id)` inside a list — cannot restart the countdown and leave
 * the toast on screen forever.
 *
 * The ref is filled in an effect rather than during render: a render-phase ref write makes the
 * React Compiler bail out and leave the whole hook unmemoized. Only the timeout callback reads it,
 * and that runs long after commit.
 */
export const useAutoDismiss = ({ duration, onDismiss, occurences }) => {
    const onDismissRef = React.useRef(onDismiss);
    React.useEffect(() => {
        onDismissRef.current = onDismiss;
    });
    React.useEffect(() => {
        if (!hasValue(duration)) {
            return;
        }
        const timeoutId = setTimeout(() => { var _a; return (_a = onDismissRef.current) === null || _a === void 0 ? void 0 : _a.call(onDismissRef); }, duration);
        return () => clearTimeout(timeoutId);
    }, [duration, occurences]);
};
